function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -14.296,
  y1: 0.908,
  x2: -16.692,
  y2: 1.492,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0083ca"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5ca31e"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 1.539,
  y1: 0.264,
  x2: -0.407,
  y2: 0.706,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 2.514,
  y1: 0.5,
  x2: 0.106,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 0.846,
  y1: 0.5,
  x2: -1.561,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1303",
  "data-name": "Group 1303",
  transform: "translate(1044.396 -14.179)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(-1023.212 28.057)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M-799.433,173.9H-807.7a2.446,2.446,0,0,0,.976,1.432,3.122,3.122,0,0,0,1.815.5,3.729,3.729,0,0,0,1.416-.244,4.148,4.148,0,0,0,1.207-.8l2.1,2.309a6,6,0,0,1-4.847,1.954,7.386,7.386,0,0,1-3.5-.8,5.766,5.766,0,0,1-2.34-2.22,6.266,6.266,0,0,1-.829-3.219,6.292,6.292,0,0,1,.808-3.186,5.786,5.786,0,0,1,2.235-2.209,6.455,6.455,0,0,1,3.211-.8,6.417,6.417,0,0,1,3.085.744,5.482,5.482,0,0,1,2.193,2.153,6.608,6.608,0,0,1,.808,3.341Q-799.37,172.9-799.433,173.9Zm-7.544-3.73a2.546,2.546,0,0,0-.787,1.51h4.659a2.551,2.551,0,0,0-.787-1.51,2.227,2.227,0,0,0-1.542-.555A2.225,2.225,0,0,0-806.977,170.172Z",
  transform: "translate(811.709 -166.62)",
  fill: "url(#linear-gradient)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(-1036.614 40.91)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M-956.944,314.722a.876.876,0,0,1-.268.105,1.484,1.484,0,0,1-.337.037,1.071,1.071,0,0,1-.748-.238.915.915,0,0,1-.261-.711v-.835h-.363v-.651h.363v-.647h.871v.647h.569v.651h-.569v.826a.293.293,0,0,0,.071.209.249.249,0,0,0,.19.076.461.461,0,0,0,.266-.078Z",
  transform: "translate(958.921 -311.42)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M-932.35,317.51a1.315,1.315,0,0,1,.489-.085v.784a1.793,1.793,0,0,0-.2-.014.607.607,0,0,0-.438.151.614.614,0,0,0-.158.463v1.142h-.872v-2.486h.83v.3A.811.811,0,0,1-932.35,317.51Z",
  transform: "translate(935.839 -316.549)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M-910.923,317.707a1.083,1.083,0,0,1,.326.865v1.38h-.812v-.321a.748.748,0,0,1-.734.362,1.15,1.15,0,0,1-.5-.1.74.74,0,0,1-.319-.273.722.722,0,0,1-.108-.392.637.637,0,0,1,.271-.548,1.438,1.438,0,0,1,.835-.195h.5q-.023-.395-.528-.394a1.212,1.212,0,0,0-.362.057.963.963,0,0,0-.312.158l-.294-.592a1.626,1.626,0,0,1,.5-.213,2.38,2.38,0,0,1,.594-.076A1.4,1.4,0,0,1-910.923,317.707Zm-.711,1.662a.408.408,0,0,0,.165-.215v-.216h-.376q-.381,0-.381.252a.222.222,0,0,0,.087.183.375.375,0,0,0,.238.069A.482.482,0,0,0-911.634,319.369Z",
  transform: "translate(917.244 -316.549)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M-878.242,307.8v3.4h-.83v-.248a.9.9,0,0,1-.729.289,1.236,1.236,0,0,1-.619-.158,1.144,1.144,0,0,1-.443-.452,1.376,1.376,0,0,1-.163-.679,1.364,1.364,0,0,1,.163-.677,1.132,1.132,0,0,1,.443-.447,1.251,1.251,0,0,1,.619-.156.9.9,0,0,1,.688.257V307.8Zm-1,2.594a.619.619,0,0,0,.147-.438.61.61,0,0,0-.145-.431.486.486,0,0,0-.374-.156.494.494,0,0,0-.376.156.6.6,0,0,0-.147.431.618.618,0,0,0,.147.438.49.49,0,0,0,.376.158A.485.485,0,0,0-879.246,310.4Z",
  transform: "translate(888.117 -307.803)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M-843.325,318.929h-1.807a.505.505,0,0,0,.213.3.712.712,0,0,0,.4.1.856.856,0,0,0,.31-.051.907.907,0,0,0,.264-.165l.459.477a1.351,1.351,0,0,1-1.06.4,1.692,1.692,0,0,1-.766-.165,1.231,1.231,0,0,1-.511-.459,1.239,1.239,0,0,1-.181-.665,1.244,1.244,0,0,1,.177-.658,1.233,1.233,0,0,1,.489-.456,1.477,1.477,0,0,1,.7-.165,1.468,1.468,0,0,1,.674.154,1.171,1.171,0,0,1,.48.445,1.308,1.308,0,0,1,.176.69Q-843.312,318.723-843.325,318.929Zm-1.649-.77a.517.517,0,0,0-.172.312h1.018a.519.519,0,0,0-.172-.312.5.5,0,0,0-.337-.115A.5.5,0,0,0-844.974,318.159Z",
  transform: "translate(856.288 -316.549)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M-812.119,317.707a1.083,1.083,0,0,1,.326.865v1.38h-.812v-.321a.748.748,0,0,1-.734.362,1.15,1.15,0,0,1-.5-.1.74.74,0,0,1-.319-.273.723.723,0,0,1-.108-.392.636.636,0,0,1,.271-.548,1.438,1.438,0,0,1,.835-.195h.5q-.023-.395-.528-.394a1.214,1.214,0,0,0-.362.057.964.964,0,0,0-.312.158l-.293-.592a1.625,1.625,0,0,1,.5-.213,2.38,2.38,0,0,1,.594-.076A1.4,1.4,0,0,1-812.119,317.707Zm-.711,1.662a.408.408,0,0,0,.165-.215v-.216h-.376q-.381,0-.381.252a.222.222,0,0,0,.087.183.376.376,0,0,0,.239.069A.481.481,0,0,0-812.83,319.369Z",
  transform: "translate(827.435 -316.549)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M-778.881,308.835a1.136,1.136,0,0,1,.44.447,1.364,1.364,0,0,1,.163.677,1.376,1.376,0,0,1-.163.679,1.148,1.148,0,0,1-.44.452,1.224,1.224,0,0,1-.617.158.9.9,0,0,1-.734-.289v.248h-.83v-3.4h.871v1.133a.927.927,0,0,1,.693-.257A1.238,1.238,0,0,1-778.881,308.835Zm-.424,1.562a.619.619,0,0,0,.147-.438.6.6,0,0,0-.147-.431.494.494,0,0,0-.376-.156.494.494,0,0,0-.376.156.6.6,0,0,0-.147.431.618.618,0,0,0,.147.438.49.49,0,0,0,.376.158A.49.49,0,0,0-779.305,310.4Z",
  transform: "translate(797.254 -307.803)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M-746.045,307.8h.871v3.4h-.871Z",
  transform: "translate(765.425 -307.803)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M-729.3,318.929h-1.807a.5.5,0,0,0,.213.3.711.711,0,0,0,.4.1.857.857,0,0,0,.31-.051.91.91,0,0,0,.264-.165l.459.477a1.351,1.351,0,0,1-1.06.4,1.691,1.691,0,0,1-.766-.165,1.232,1.232,0,0,1-.512-.459,1.24,1.24,0,0,1-.181-.665,1.246,1.246,0,0,1,.177-.658,1.232,1.232,0,0,1,.489-.456,1.477,1.477,0,0,1,.7-.165,1.468,1.468,0,0,1,.674.154,1.172,1.172,0,0,1,.479.445,1.307,1.307,0,0,1,.177.69Q-729.291,318.723-729.3,318.929Zm-1.649-.77a.517.517,0,0,0-.172.312h1.018a.518.518,0,0,0-.172-.312.5.5,0,0,0-.337-.115A.5.5,0,0,0-730.954,318.159Z",
  transform: "translate(752.648 -316.549)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M-699.608,319.922a1.618,1.618,0,0,1-.486-.186l.262-.6a1.474,1.474,0,0,0,.4.167,1.806,1.806,0,0,0,.463.062.743.743,0,0,0,.3-.043.137.137,0,0,0,.089-.126q0-.082-.108-.117a2.242,2.242,0,0,0-.342-.066,3.354,3.354,0,0,1-.507-.1.78.78,0,0,1-.36-.22.63.63,0,0,1-.151-.449.68.68,0,0,1,.142-.424.942.942,0,0,1,.415-.293,1.778,1.778,0,0,1,.654-.108,2.644,2.644,0,0,1,.537.055,1.541,1.541,0,0,1,.445.156l-.261.592a1.45,1.45,0,0,0-.716-.184.711.711,0,0,0-.3.048.143.143,0,0,0-.1.126c0,.058.035.1.105.122a2.425,2.425,0,0,0,.349.071,3.858,3.858,0,0,1,.509.106.78.78,0,0,1,.351.218.62.62,0,0,1,.149.443.672.672,0,0,1-.142.42.924.924,0,0,1-.42.291,1.88,1.88,0,0,1-.667.105A2.682,2.682,0,0,1-699.608,319.922Z",
  transform: "translate(723.657 -316.549)",
  fill: "#0083ca"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4",
  transform: "translate(-1036.616 24.072)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M-948.5,139.262l-4.344-5.653h-2.243v5.653h-3.85V122.845h6.793a8.193,8.193,0,0,1,4.94,1.357h0a4.8,4.8,0,0,1,2.023,4.066,4.7,4.7,0,0,1-2,4.014,6.116,6.116,0,0,1-1.392.74l4.822,6.24Zm-6.588-9.185h2.943a4.448,4.448,0,0,0,2.517-.571,1.336,1.336,0,0,0,.6-1.219,1.465,1.465,0,0,0-.618-1.322,4.283,4.283,0,0,0-2.494-.587h-2.943Z",
  transform: "translate(958.938 -122.845)",
  fill: "url(#linear-gradient-2)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M-1037.78,94.922c-3.987-1.144-6.616-2.964-6.616-4.444v3.553c0,1.48,2.629,2.657,6.616,3.325Z",
  transform: "translate(0 -69.353)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M-1029.885,18.8l-5.963-4.624v2.437c-5.048.908-8.548,2.8-8.548,4.509v3.553c0-1.708,3.5-2.829,8.548-3.313v2.063Z",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M-664.621,307.517v2.773c2.56,1.082,4.135,2.43,4.135,3.576v-3.553C-660.486,309.168-662.061,308.2-664.621,307.517Z",
  transform: "translate(-345.201 -266.633)",
  fill: "#0083ca"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M-778.6,344.1l5.963,4.624v-2.437c5.048-.908,8.548-2.8,8.548-4.509v-3.553c0,1.708-3.5,2.829-8.548,3.313v-2.063Z",
  transform: "translate(-241.602 -294.547)",
  fill: "url(#linear-gradient-4)"
}));

var SvgLogoSmallRtr = function SvgLogoSmallRtr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.71,
    height: 40,
    viewBox: "0 0 38.71 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSmallRtr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-small-rtr.c46477d2.svg";
export { ForwardRef as ReactComponent };